import styled from 'styled-components';
import { colors, device } from '../../styles/stylesheets';
import { ContainerShadowStyled } from '../ContainerShadowStyled';

export const Container = styled(ContainerShadowStyled)`
  position: relative;
  :hover {
    cursor: pointer;
  }
`;

export const ContainerPopular = styled(Container)`
  width: 228px;
`;

export const ContainerMost = styled(Container)`
  width: calc(50% - 12px);
  min-height: 100px;
  display: grid;
  grid-template: "photo title" 
    "photo category" / 100px 1fr;
  @media ${device.untilTablet} {
    width: 100%;
  }
`;

const CardImage = styled.div`
  grid-area: photo;
  background: url(${({ url }) => url}) center top no-repeat, 
    ${({ imgDefault }) => imgDefault && `url(${imgDefault})  center center no-repeat,`}
    ${colors.white};
`;

export const CardImagePopular = styled(CardImage)`
  border-radius: 4px 4px 0 0;
  height: 150px;
  background-size: cover;
`;

export const CardImageMost = styled(CardImage)`
  border-radius: 4px;
  height: 70px;
  width: 80px;
  margin: 16px 0 16px 16px;
  background-size: cover;
`;

export const CardTitle = styled.h3`
  grid-area: title;
  display: block;
  margin: 16px;
  line-height: 20px;
  font-weight: 400;
  padding-bottom: calc(4px + 16px);
`;

export const CardCategory = styled.div`
  grid-area: category;
  display: block;
  position: absolute;
  bottom: 0;
  margin: 4px 16px 16px;
  line-height: 16px;
  font-size: 12px;
  color: ${colors.primary};
  text-decoration: none;
`;
